import { axios } from '@/utils/axios';
export interface QualifiedCompany {
  id: number;
  profession: 'company';
  profile: { business_name: string };
}
export const getQualifiedCompanies = (
  after?: number,
  filters?: { acc_coname?: string; acc_country?: string; category?: string }
) =>
  axios.get<{ data: { items: QualifiedCompany[]; next_cursor: number | null } }>('/api/directory/v2/companies', {
    params: { after, ...filters },
    skipAuthRefresh: true,
  });
export type IdentityKind = 'company' | 'barrister' | 'individual';
export interface IdentityRequest {
  resolution?: { text: string; hash: string; confirmed_at: string | null } | null;
  id: number;
  kind: IdentityKind;
  version: number;
  status: string;
  profile: Record<string, unknown>;
  has_evidence: boolean;
  reason: string;
  review_reason: string | null;
  created_at: string;
}
export interface PurchaseSelection {
  product_code: string;
  version: number;
  status: string;
  expires_at: string | null;
  language: 'en' | 'tc' | 'sc';
  source_group: 'free' | 'standard' | 'legal';
}
export interface IdentityState {
  current_identity?: IdentityKind;
  qualifications: Record<
    'company' | 'barrister',
    { active: boolean; status: string; version: number; valid_until: string | null; publication_status?: string }
  >;
  requests: IdentityRequest[];
  selection: PurchaseSelection | null;
}
export const getIdentity = () => axios.get<{ data: IdentityState }>('/api/account/v2/identity');
export const cancelIdentitySelection = (expected_version: number) =>
  axios.delete('/api/account/v2/identity/selection', { data: { expected_version } });
export const setIdentityPublication = (kind: IdentityKind, consent: boolean) =>
  axios.patch('/api/account/v2/identity/publication/' + kind, { consent });
export const submitIdentity = (data: FormData) => axios.post('/api/account/v2/identity/requests', data);
export const withdrawIdentity = (id: number) => axios.post('/api/account/v2/identity/requests/' + id + '/withdraw');
export const confirmIdentityResolution = (id: number, resolution_hash: string) =>
  axios.post('/api/account/v2/identity/requests/' + id + '/resolution', { resolution_hash, confirmed: true });
export const saveSelection = (product_code: string, language: string, source_group: string, expected_version: number) =>
  axios.put<{ data: PurchaseSelection }>('/api/account/v2/identity/selection', {
    product_code,
    language,
    source_group,
    expected_version,
  });
